// Defaults to the light treatment: a white disc with a hairline border and a soft
// brand-tinted lift, carrying the mark in its real brand colours. The dark disc forced the
// white cut-out variant, which threw away the brand palette and read as a heavy black dot
// against the chat's very light background. `tone="dark"` is still available for placing
// the avatar on a dark surface.
const DashAvatar = ({ thinking = false, tone = 'light', intro = false }) => {
    const isDark = tone === 'dark';

    return (
        <div
            className={`hidden sm:flex flex-shrink-0 relative w-8 h-8 md:w-9 md:h-9 rounded-full items-center justify-center mt-1 border ${intro ? 'animate-dash-intro-pop' : ''} ${
                isDark
                    ? 'bg-black border-black/5 shadow-sm'
                    : 'bg-white border-neutral-200 shadow-[0_6px_18px_rgba(0,0,0,0.08)]'
            }`}
        >
            {thinking && (
                <span className="pointer-events-none absolute -inset-1.5 rounded-full border border-[#D81F26]/40 dash-thinking-ring" />
            )}
            {/* Dedicated white artwork on the dark circle rather than CSS `invert` on the
                dark logo — inverting a full-colour mark muddies it to near-invisible, which
                is exactly how the old asset rendered here. */}
            <img
                src={isDark ? '/PNG/carfido-icon-white.png' : '/PNG/carfido-icon-transparent.png'}
                alt="CarFido"
                className={`w-5 md:w-6 object-contain ${thinking ? 'dash-thinking-logo' : ''}`}
            />
        </div>
    );
};

export default DashAvatar;
